import { grey } from "./colors/index.js";
const text_text = (mode)=>{
    const accent = grey["300"];
    return 'light' === mode ? {
        primary: grey["950"],
        secondary: grey["600"],
        disabled: grey["300"],
        inversePrimary: grey["50"],
        inverseSecondary: grey["200"],
        navigationHeader: grey["200"],
        accent
    } : {
        primary: grey["50"],
        secondary: grey["200"],
        disabled: grey["500"],
        inversePrimary: grey["950"],
        inverseSecondary: grey["600"],
        navigationHeader: grey["200"],
        accent
    };
};
export { text_text as text };

//# sourceMappingURL=text.js.map